<template>
  <div>
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>网站设置</el-breadcrumb-item>
      <el-breadcrumb-item>SEO设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="SEOForm">
      <el-form-item label="网站标题">
        <el-input v-model="SEOForm.title"></el-input>
      </el-form-item>
      <el-form-item label="网站标签">
        <el-input v-model="tagStr" @keyup.enter.native="subTag(tagStr)"></el-input>
        <el-tag
          :key="tag"
          v-for="tag in SEOForm.tag"
          closable
          :disable-transitions="false"
          @close="removeTag(tag)">
          {{tag}}
        </el-tag>
      </el-form-item>
      <el-form-item label="网站描述">
        <el-input v-model="SEOForm.describe"></el-input>
      </el-form-item>
    </el-form>
       <el-button class="buttonddd" type="primary" @click="save">保存</el-button>
       
    <Backfooter></Backfooter>
  </div>
</template>
<script>
import Backfooter from '../../components/dashu/backfooter';
export default {
  components:{Backfooter,},
  data() {
    return {
      SEOForm: {
        title: '',
        tag: [],
        describe: '',
        id:''
      },
      tagStr: ''
    }
  },
  methods: {
    save () { 
      this.$http.post('/admin/dashu/seo/update', {
          id:this.SEOForm.id,
          title:this.SEOForm.title,
          describe:this.SEOForm.describe,
          label:this.SEOForm.tag,
      }).then( (res)=> {
       var code=res.data.code;
        //  console.log(res.data.data)
       if (code===0){
            this.$message({
                        type: 'success',
                        message: '保存成功!'
                  });
       }
      }).catch(function (error) {
        //  console.log(error);
     });
     
    },
    // 增加标签
    subTag (tagStr) {
      this.SEOForm.tag.push(tagStr)
      this.tagStr = ''
    },
    // 移除标签
    removeTag (tag) {
      // console.log(tag)
      this.SEOForm.tag.splice(this.SEOForm.tag.indexOf(tag), 1);
      // console.log(this.SEOForm.tag)
    }
  },
  created(){
     this.$http.post('/admin/dashu/seo/seoList', {
      }).then( (res)=> {
       var code=res.data.code;
       if (code===0){
        this.SEOForm.describe=res.data.data.lists.describe;
        this.SEOForm.title=res.data.data.lists.title;
        this.SEOForm.tag=res.data.data.lists.label;
        this.SEOForm.id=res.data.data.lists.id;
       }
      }).catch(function (error) {
        //  console.log(error);
     });
     
  }
}
</script>
<style scoped> 
</style>



// WEBPACK FOOTER //
// src/pages/backPages/SEO.vue